<div class="app-container">
  <!-- Sidebar Component -->
  <app-sidebar
    [isCollapsed]="isSidebarCollapsed"
    (toggleSidebar)="onToggleSidebar()"
    (closeSidebar)="onCloseSidebar()"
  ></app-sidebar>

  <!-- Main Content Area -->
  <div class="main-content" [class]="mainContentClass">
    <!-- Top Bar for Desktop -->
    <div class="top-bar" *ngIf="false">
      <div class="top-bar-content">
        <div class="breadcrumb-section" *ngIf="pageInfo$ | async as pageInfo">
          <div class="page-title">
            <h1>{{ pageInfo.title }}</h1>
            <p *ngIf="pageInfo.subtitle">{{ pageInfo.subtitle }}</p>
          </div>
          <div class="breadcrumbs" *ngIf="pageInfo.breadcrumbs && pageInfo.breadcrumbs.length > 0">
            <span
              *ngFor="let breadcrumb of pageInfo.breadcrumbs; let last = last"
              class="breadcrumb-item"
              [class.active]="last"
            >
              <a *ngIf="!last && breadcrumb.url" [routerLink]="breadcrumb.url">{{
                breadcrumb.label
              }}</a>
              <span *ngIf="last || !breadcrumb.url">{{ breadcrumb.label }}</span>
              <i *ngIf="!last" class="pi pi-chevron-right"></i>
            </span>
          </div>
        </div>
        <div class="top-bar-actions">
          <!-- Additional actions can go here -->
        </div>
      </div>
    </div>

    <!-- Page Content -->
    <div class="page-content">
      <div class="content-wrapper">
        <ng-content></ng-content>
      </div>
    </div>

    <!-- Footer -->
    <div class="app-footer" *ngIf="false">
      <div class="footer-content">
        <span class="copyright">© STEM Connect {{ currentYear }}</span>
      </div>
    </div>
  </div>
</div>
